<div class="row mb-4">
  @for (category of categories; track category.taskCategoryId) {
    <div class="checkbox mb-2">
      @if (category.onlineAppEnabled) {
        <label class="form-check form-check-inline form-check-solid me-2" for="char_{{category.taskCategoryId}}">
          <input id="char_{{category.taskCategoryId}}" name="char_{{category.taskCategoryId}}" type="checkbox"
            (change)="onCharacteristicCheckChanged(category.taskCategoryId, borrowerId)"
            [checked]="isCharacteristicCheckedForLoan(category.taskCategoryId)" class="form-check-input">
          <span class="fw-bold ps-2 fs-5">{{category.questionText}}</span>
        </label>
        @if (category.taskOption === 'RequestQuantity') {
          <span>
            <a class="text-primary" (click)="openEditCharacteristicDialog(category, borrowerId, false)"> {{'(' +
              getCharacteristicQuantity(category.taskCategoryId) + ')'}}</a>
          </span>
        }
      }
    </div>
  }
</div>
